import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { defaultServerUrls, environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { notifications } from '@paragon/notification-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { SyncClient } from '../../../../libraries/sync-client';
import { assemblyGroupsSlice } from './assemblyGroupsSlice';
import { componentDesignsSlice } from './componentDesignsSlice';
import { linesSlice } from './linesSlice';
import { popup } from './popupSlice';
import { stationsSlice } from './stationsSlice';
import { trailersSlice } from './trailersSlice';
import { truckDriversSlice } from './truckDriversSlice';

const rootReducer = combineReducers({
  assemblyGroups: assemblyGroupsSlice.reducer,
  componentDesigns: componentDesignsSlice.reducer,
  environment,
  lines: linesSlice.reducer,
  logInData,
  notifications,
  popup,
  spinnerMessages,
  stations: stationsSlice.reducer,
  trailers: trailersSlice.reducer,
  truckDrivers: truckDriversSlice.reducer,
  theme,
});

export const syncClient = new SyncClient({
  serverUrl: defaultServerUrls[process.env.APP_ENV!].synchronizationServerUrl,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(syncClient.state.middleware),
});

syncClient.state.store = store;

syncClient.on('error', (event: any) => {
  console.error('sync error', event);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
